import dayjs from 'dayjs'
export default {
  name: 'company-notice-list',
  data () {
    return {
      currentPage: 0,
      totalPages: 0,
      prevExist: false,
      nextExist: false,
      companyNoticeList: [],
      searchEnd: false
    }
  },
  filters: {
    formatDate (date) {
      return dayjs(date).format('YYYY/MM/DD')
    }
  },
  created () {
    const currentPage = (this.$route.query.current_page) ? parseInt(this.$route.query.current_page) : 0
    const addSearch = this.$route.query.current_page !== false
    this.search(addSearch, currentPage)
  },
  methods: {
    goTop () {
      this.$router.push({ path: '/' })
    },
    goCompanyNoticeDetail (id) {
      this.$router.push({path: `/company_notice/${id}/detail`, query: {current_page: this.currentPage}})
    },
    async search (addSearch, searchPage) {
      this.searchEnd = false
      this.currentPage = searchPage
      const data = {
        current_page: this.currentPage,
        add_search: addSearch
      }
      const res = await this.$store.dispatch('GET_COMPANY_NOTICE_LIST', { data: data })
      .catch(err => {
        console.error(err)
        return
      })
      this.companyNoticeList = res.company_notices
      this.prevExist = res.prev_exist
      this.nextExist = res.next_exist
      this.totalPages = res.total_pages
      this.searchEnd = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/company-notice-list.js